export default __webpack_public_path__ + "static/media/pool-area.41f23c7e.png";